import { render, staticRenderFns } from "./ConfigureEmployeeDocumentDraft.vue?vue&type=template&id=89654130&scoped=true"
import script from "./ConfigureEmployeeDocumentDraft.vue?vue&type=script&lang=js"
export * from "./ConfigureEmployeeDocumentDraft.vue?vue&type=script&lang=js"
import style0 from "./ConfigureEmployeeDocumentDraft.vue?vue&type=style&index=0&id=89654130&prod&lang=scss&scoped=true"
import style1 from "./ConfigureEmployeeDocumentDraft.vue?vue&type=style&index=1&id=89654130&prod&lang=scss"
import style2 from "./ConfigureEmployeeDocumentDraft.vue?vue&type=style&index=2&id=89654130&prod&scoped=true&lang=css"
import style3 from "./ConfigureEmployeeDocumentDraft.vue?vue&type=style&index=3&id=89654130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89654130",
  null
  
)

export default component.exports